module.exports = __webpack_public_path__ + "static/half-screen-landing-svg.25adfc65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/half-screen-landing-svg.svg
// module id = 909
// module chunks = 35783957827783 112643250470497